import { goToToday } from 'owa-calendar-module-commanding';
import { ControlIcons } from 'owa-control-icons';
import { DisplayOption, FilterableMenuItem, FilterableMenuItemArgs } from 'owa-filterable-menu';
import loc from 'owa-localize';
import { todayStringLowerCaseText } from 'owa-calendar-shared-strings/lib/strings/calendarSurfaceCommandBar.locstring.json';
import { getTodayLabel } from '../utils/getSurfaceNavigationStrings';

export function getGoToTodayMenuItem() {
    const goToTodayLabel = getTodayLabel();
    return new FilterableMenuItem({
        [FilterableMenuItemArgs.name]: loc(todayStringLowerCaseText),
        [FilterableMenuItemArgs.icon]: ControlIcons.GotoToday,
        [FilterableMenuItemArgs.onClick]: goToToday,
        [FilterableMenuItemArgs.displayOption]: DisplayOption.Left,
        [FilterableMenuItemArgs.ariaLabel]: goToTodayLabel,
        [FilterableMenuItemArgs.title]: goToTodayLabel,
    });
}
